export const GET_LICENSES_REQUEST = 'GET_LICENSES_REQUEST';
export const GET_LICENSES_SUCCESS = 'GET_LICENSES_SUCCESS';
export const GET_LICENSES_FAILURE = 'GET_LICENSES_FAILURE';

export const GET_TRACK_USAGE_REQUEST = 'GET_TRACK_USAGE_REQUEST';
export const GET_TRACK_USAGE_SUCCESS = 'GET_TRACK_USAGE_SUCCESS';
export const GET_TRACK_USAGE_FAILURE = 'GET_TRACK_USAGE_FAILURE';